// Email domains allowed to sign up and sign in (Google and email/password).
// Shared by the Login and Signup pages so they can't drift apart. The Go
// backend enforces its own copy via the ALLOWED_EMAIL_DOMAIN env var (see
// server/auth/firebase.go) — add a new domain there too.
export const allowed_domains = [
  'taxtitansusa.com',
  'quicklyflowing.com',
  'omnimedia.io',
  'capturedleads.com'
];
